import { Shark } from "shark-mvc";

import NousCoreModel from "./NousCoreModel";

class CustomTagsCategory extends NousCoreModel {
	name = "";
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}
}

Shark.registerModel("CustomTagsCategory", CustomTagsCategory);

export default CustomTagsCategory;